import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CategoryFilterModel, CategoryModel } from 'src/app/models/Category.model';
import { NewsService } from 'src/app/services/News/news.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-news-filter-component',
  templateUrl: './news-filter-component.component.html',
  styleUrls: ['./news-filter-component.component.scss'],
  standalone: false,
})
export class NewsFilterComponent {
  constructor(
    private popoverCtrl: PopoverController,
    private sharedService: SharedService,
    private translate: TranslateService,
    private categoryService: NewsService,
  ) {}
  private filterSubject = new Subject<CategoryFilterModel>();
  @Input() categories: any;
  @Input() category: any = new CategoryModel();
  filter: CategoryFilterModel = {
    Search: '',
    PageIndex: 0,
    PageSize: 20,
    Language: this.translate.currentLang,
  };
  empty = false;

  ngOnInit() {
    this.category == null ? (this.category = new CategoryModel()) : null;
    this.listCategoriesSwitch(this.filterSubject.asObservable()).subscribe(
      (categories: CategoryModel[]) => {
        if (this.filter.Event) {
          if (categories.length === 0) {
            this.sharedService.showToast(this.translate.instant('common.emptyResult'));
          } else {
            this.categories = this.categories.concat(categories);
          }
        } else {
          categories.length == 0 ? (this.empty = true) : (this.empty = false);
          this.categories = categories;
        }
      },
      () => {
        this.empty = false;
      },
    );
  }

  listCategoriesSwitch(filter: Observable<CategoryFilterModel>): Observable<CategoryModel[]> {
    return filter.pipe(switchMap((filter: CategoryFilterModel) => this.categoryService.getCategories(filter)));
  }

  addFilterChange(filter: CategoryFilterModel) {
    this.filterSubject.next(filter);
  }

  search() {
    this.addFilterChange(this.filter);
  }

  async close(category: CategoryModel) {
    if (category.id === this.category.id) {
      this.category = new CategoryModel();
      await this.popoverCtrl.dismiss(null);
    } else {
      this.category = new CategoryModel();
      await this.popoverCtrl.dismiss(category);
    }
  }

  async ngOnDestroy() {
    this.filterSubject?.unsubscribe();
  }
}
